module.exports = __webpack_public_path__ + "static/media/story_06.35581f94.jpg";